module.exports = __webpack_public_path__ + "img/Therapeutic, recreational, physical activities.a56e48ff.png";